import OptInFirstRunLightningModal from './OptInFirstRunLightningModal';
import UserVoiceNpsLightningCallout from './UserVoiceNpsLightningCallout';
import { LightningId } from 'owa-lightning-v2';
import { isFeatureEnabled } from 'owa-feature-flags';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { TargetedAdsPrompt } from 'owa-targeted-ads-opt-in';
import { TargetedAdsV2Prompt } from 'owa-gdpradsv2-optin';
import { OptInFirstRunExperienceVersion } from 'owa-mail-fre-view';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import WebSessionType from 'owa-service/lib/contract/WebSessionType';
import NewConsumerRecruitmentFormCallout from './NewConsumerRecruitmentFormCallout';
import SuiteNpsLightningCallout from './SuiteNpsLightningCallout';
import ClientTypeOptInState from 'owa-service/lib/contract/ClientTypeOptInState';

const primaryViewContainer = document.createElement('div');
primaryViewContainer.id = 'lpv';

class LightningPrimaryView extends React.Component<{}, {}> {
    render(): JSX.Element | false {
        return (
            <div>
                <OptInFirstRunLightningModal
                    version={OptInFirstRunExperienceVersion.EnterprisePreview}
                    lid={LightningId.EnterpriseOptInFRE} // lightning id
                    when={this.lightUpForEnterprisePreview}
                />
                <OptInFirstRunLightningModal
                    version={OptInFirstRunExperienceVersion.EnterpriseCutover}
                    lid={LightningId.BusinessCutoverCarousel} // lightning id
                    when={this.lightUpForEnterpriseCutover}
                />
                <TargetedAdsPrompt />
                <TargetedAdsV2Prompt />
                <UserVoiceNpsLightningCallout
                    lid={LightningId.UserVoiceSatisfactionFirstRun} // lightning id
                    when={this.onNpsLightUp}
                    isFirstSurvey={true}
                />
                <UserVoiceNpsLightningCallout
                    lid={LightningId.UserVoiceSatisfactionSecondRun} // lightning id
                    when={this.onNpsLightUp}
                    isFirstSurvey={false}
                />
                <NewConsumerRecruitmentFormCallout
                    lid={LightningId.NewConsumerRecruitmentCampaign} // lightning id
                    when={this.onNewConsumerRecruitmentLightUp}
                />
                <SuiteNpsLightningCallout
                    isFirstSurvey={true}
                    lid={LightningId.SuiteNps} // Suite Nps lightning id
                    when={this.onSuiteNpsLightUp}
                />
            </div>
        );
    }

    private onNpsLightUp(lightup) {
        const { PolicySettings } = getUserConfiguration();
        if (isFeatureEnabled('usv-nps') && PolicySettings.NpsSurveysEnabled) {
            setTimeout(() => lightup(), 1000);
        }
    }

    private onNewConsumerRecruitmentLightUp(lightup) {
        if (isFeatureEnabled('feedback-new-consumer-recruitment')) {
            lightup();
        }
    }

    private onSuiteNpsLightUp(lightup) {
        const { PolicySettings } = getUserConfiguration();
        if (isFeatureEnabled('office-suite-nps') && PolicySettings.NpsSurveysEnabled) {
            lightup();
        }
    }

    private lightUpForEnterprisePreview(lightup) {
        const { SessionSettings, UserOptions } = getUserConfiguration();
        if (
            SessionSettings.WebSessionType === WebSessionType.Business &&
            // Don't show when graduation is enabled
            !UserOptions.ReactOptinSettings?.MailGraduatedFromBeta
        ) {
            lightup();
        }
    }

    private lightUpForEnterpriseCutover(lightup) {
        const { SessionSettings, UserOptions } = getUserConfiguration();
        // Only show for cut over business users.
        // We will know that they have been cut over because their opt in state
        // indicates they are not in react, but the cutover flight is enabled.
        if (
            SessionSettings.WebSessionType === WebSessionType.Business &&
            UserOptions.ReactOptinSettings &&
            UserOptions.ReactOptinSettings.MailGraduatedFromBeta &&
            UserOptions.ClientTypeOptInState !== ClientTypeOptInState.React
        ) {
            lightup();
        }
    }
}

export default function loadLightningPrimaryView() {
    document.body.appendChild(primaryViewContainer);
    ReactDOM.render(<LightningPrimaryView />, primaryViewContainer);
}
